<lib-navigation [navGroups]="links()" layout="list" [homeItem]="homeItem" [saniupEmployee]="true">
  <router-outlet></router-outlet>
</lib-navigation>
